<mat-expansion-panel class="shadow-none border-gray-300 border-solid border mt-3">
    <mat-expansion-panel-header [title]="">{{"cancel_request_details"|translate}}</mat-expansion-panel-header>

    <div class="card-divider my-1 mb-2"></div>

    <div>{{("cancel_request_note" | translate) + ((cancelData?.note) || "-")}}</div>

    <div *ngIf="cancelData?.request?.timestamp" class="text-sm">{{"request_date"|translate }} {{ cancelData?.request?.timestamp |date:'medium' }}</div>

</mat-expansion-panel>



